<div class="fancy-hero-one">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 col-lg-11 m-auto">
          <!-- <div class="page-title">Contact us</div> -->
          <h2 class="font-rubik">Bill Details</h2>
        </div>
      </div>
    </div>
  </div>

  <div class="hero-banner-one contact-us-light">
    <div class="hero-upper-container">
      <div class="container">
        <form #paymentForm="ngForm" (submit)="makePayment()">
        <div class="details_wrap">
            <ul>
                <li><label>Name : </label>{{billData?.consumer?.name}}</li>
                <li><label>Email : </label>{{billData?.consumer?.email}}</li>
                <li><label>Mobile : </label>{{billData?.consumer?.mobile_no}}</li>
                <li><label>Address : </label>{{billData?.consumer?.address}}</li>
            </ul>
            <ul>
                <li><label>Current Amount : </label> {{billData?.bill?.amount}}</li>
                <li><label>Late Fees : </label> {{billData?.bill?.late_fee}}</li>
                <li><label>Due Date : </label> {{billData?.bill?.due_date | date : 'dd/MM/YYYY'}}</li>
                <li><label>Total Amount : </label> {{billData?.payable_total_amount}}</li>
            </ul>
                <div class="input-group-meta input_pay form-group mb-25">
                  <label>Is Partial Payment</label>
                  <input  style="margin-left: 10px;" type="checkbox" name="is_partial_payment"
                   [(ngModel)]="is_partial_payment" (ngModelChange)="onPartialPaymentChange()">
                </div>

                  <div class="form-style-light input_pay">
                    <div *ngIf="is_partial_payment" class="input-group-meta form-group mb-25">
                      <label>Amount</label>
                      <input  type="number" name="amount" #amountInpt="ngModel" [(ngModel)]="amount"  [min]="billData?.bill?.amount || 0">
                   <h6 style="display: block;" *ngIf="amountInpt.errors && amountInpt.errors['min'].min">Amount must be greater than or equal to {{amountInpt.errors && amountInpt.errors['min'].min}}</h6>
                    </div>
                  </div>

                  <button class="theme-btn-one btn-lg" [disabled]="!paymentForm.valid"
                    >Pay</button>
        </div>
        </form>
      </div>
  </div>
  </div>
  